import { useQuery } from "urql";

import { KycResultDetailDocument } from "../../../graphql/generated";

interface UseKYCResultDetailProps {
  id: number;
  pause?: boolean;
}

export const useKYCResultDetail = ({
  id,
  pause = false,
}: UseKYCResultDetailProps) => {
  return useQuery({
    query: KycResultDetailDocument,
    variables: { id },
    pause,
  });
};
